import React from 'react';
import  SpinnerIcon from './SpinnerIcon';
const Spinner = props =>(
    <div className="Spinner">
<SpinnerIcon/>


    </div>
   );

    export default Spinner;









// WEBPACK FOOTER //
// ./src/components/views/Snowflake/as/Spinner.js